<rt-form-field>
  <rt-label>
    {{ 'app.interview.due_date' | translate }}
    <rt-icon-help
      [rtTooltip]="'app.interview.due_date_help' | translate"
      rtTooltipPosition="right"
      margin-left-small-xx
    />
    <rt-badge color="pink-gradient" [text]="'app.common.new' | translate" margin-left-small-x />
  </rt-label>

  <rt-due-date-field
    [value]="dueDate()"
    [showTimezone]="false"
    [relativeLabel]="'app.interview.due_date_after_request_sent' | translate"
    [submitLabel]="'app.interview.add_due_date' | translate"
    [placeholder]="'app.interview.due_date_placeholder' | translate"
    (valueChange)="onDateChange($event)"
  />
</rt-form-field>
